
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * This file should be your main import to use Prisma-related types and utilities in a browser. 
 * Use it to get access to models, enums, and input types.
 * 
 * This file does not contain a `PrismaClient` class, nor several other helpers that are intended as server-side only.
 * See `client.ts` for the standard, server-side entry point.
 *
 * 🟢 You can import this file directly.
 */

import * as Prisma from './internal/prismaNamespaceBrowser'
export { Prisma }
export * as $Enums from './enums'
export * from './enums';
/**
 * Model Ad
 * 
 */
export type Ad = Prisma.AdModel
/**
 * Model Tool
 * 
 */
export type Tool = Prisma.ToolModel
/**
 * Model ToolRepository
 * 
 */
export type ToolRepository = Prisma.ToolRepositoryModel
/**
 * Model Repository
 * 
 */
export type Repository = Prisma.RepositoryModel
/**
 * Model CatalogFieldEvidence
 * 
 */
export type CatalogFieldEvidence = Prisma.CatalogFieldEvidenceModel
/**
 * Model RepositoryReview
 * 
 */
export type RepositoryReview = Prisma.RepositoryReviewModel
/**
 * Model Category
 * 
 */
export type Category = Prisma.CategoryModel
/**
 * Model Tag
 * 
 */
export type Tag = Prisma.TagModel
/**
 * Model Report
 * 
 */
export type Report = Prisma.ReportModel
/**
 * Model BrandMention
 * 
 */
export type BrandMention = Prisma.BrandMentionModel
/**
 * Model NewsletterSubscription
 * 
 */
export type NewsletterSubscription = Prisma.NewsletterSubscriptionModel
/**
 * Model AlternativePage
 * 
 */
export type AlternativePage = Prisma.AlternativePageModel
/**
 * Model Alternative
 * 
 */
export type Alternative = Prisma.AlternativeModel
/**
 * Model Bookmark
 * 
 */
export type Bookmark = Prisma.BookmarkModel
/**
 * Model Post
 * 
 */
export type Post = Prisma.PostModel
